export default __webpack_public_path__ + "static/media/g2.f46027e5.jpg";